// extracted by mini-css-extract-plugin
export default {"container":"OneToOneSalesAmountModal_container__VQWYH","btns_container":"OneToOneSalesAmountModal_btns_container__dqT5i","cancel_btn":"OneToOneSalesAmountModal_cancel_btn__el2Hq"};